import { HolidayTripData } from 'api/holiday-trip-detail';
import { autoinject, BindingEngine, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ValidationRules } from 'aurelia-validation';
import { HolidayTrip, initHolidayMaker, initRelatedTraveler } from 'model/forms/holiday-trip';
import { ModelBase } from 'support/base_classes/model-base';

@autoinject
@customElement('holiday-trip-form')
export class HolidayTripFormCustomElement extends ModelBase<HolidayTrip | HolidayTripData> {
  @bindable autofocus = false;
  @bindable disabled = false;

  constructor(bindingEngine: BindingEngine) {
    super(bindingEngine);
  }

  modelChanged(newValue: HolidayTrip | HolidayTripData) {
    super.modelChanged(newValue);

    ValidationRules
      .ensureObject<HolidayTrip>().required()
      .ensure(model => model.name).displayName('Trip name').required()
      .ensure(model => model.travelers).displayName('Travellers section').minItems(1)
      .ensure(model => model.segments).displayName('Trip Details section').minItems(1)
      .on(this.model);
  }

  addTraveler() {
    const traveler = initHolidayMaker({ relatedTravelers: [initRelatedTraveler()] });
    this.model.travelers.push(traveler);
  }
}
